export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StoryBackground.vue?vue&type=template&id=2fd50240&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/components/StoryBackground.vue?vue&type=template&id=2fd50240&
// module id = 1048
// module chunks = 0